import { auth } from "../../conf/firebase";
import myAxios from "../../utils/axiosWrapper";
import { ALGOLIA_FETCH, ALGOLIA_FETCH_SUCCESS, ALGOLIA_FETCH_FAILURE } from "../actionTypes";
import getConfig from "../../conf/config";

export const getAlgoliaInfos = () => async (dispatch) => {
  dispatch({ type: ALGOLIA_FETCH });
  try {
    const { currentUser } = auth;
    if (!currentUser || currentUser === null) {
      const errorMessage = "Not fetching algolia infos, user not authenticated";
      console.error(errorMessage);
      dispatch({
        type: ALGOLIA_FETCH_FAILURE,
        payload: errorMessage,
      });
      return;
    }

    const base_url = `${getConfig().API_URL}/audio/api/v1/algolia`;
    const response = await myAxios.get(base_url);
    const algoliaInfos = response.data;
    dispatch({ type: ALGOLIA_FETCH_SUCCESS, payload: algoliaInfos });
    return algoliaInfos;
  } catch (error) {
    console.error("Error fetching Algolia infos:", error); // Log errors
    dispatch({ type: ALGOLIA_FETCH_FAILURE, payload: error });
  }
};
